// extracted by mini-css-extract-plugin
export default {"bookingCardPreview":"dndPreview_bookingCardPreview__4uGUw"};